import React, { useEffect, useContext, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  InputAdornment,
  TextField,
  Select,
  FormControl,
  MenuItem,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
// icon
import { LuSearch } from "react-icons/lu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// src
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import FooterPagination from "../../Components/Include/FooterPagination";
import StudentAction from "../../Components/Students/StudentForm/StudentAction";
import { GET_STUDENT_PAGINATION } from "../../Schema/Student";
import {
  SelectSchool,
  SelectLevel,
  SelectGroup,
  SelectTeacher,
  SelectAcademicYear
} from "../../Function/DynamicSelect";
import { GET_ACTIVE_ACADEMIC_YEAR } from "../../Schema/AcademicYear"
import StudentBtnMenu from "../../Components/Students/StudentBtnMenu";
import StudentEnrollmentAction from "../../Components/Students/StudentDetail/StudentEnrollment/StudentEnrollmentAction"

export default function Student() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const navigate = useNavigate();
  let userLogin = JSON.parse(window.localStorage.getItem("logIn"));

  const [loading, setLoading] = useState(true);

  const [academicYearVal, setAcademicYearVal] = useState({ id: null, title: "", });
  const [levelVal, setLevelVal] = useState({ id: "", title: "" });
  const [schoolVal, setSchoolVal] = useState({ id: "", title: "" });
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });
  const [teacherVal, setTeacherVal] = useState({ id: "", title: "" });
  const [studyStatusVal, setStudyStatusVal] = useState("All");

  useEffect(() => {
    if (userLogin?.role === "Teacher") {
      setTeacherVal({ id: userLogin?._id, title: language === "en" ? userLogin?.latin_name : userLogin?.last_name + " " + userLogin?.first_name })
    }
  }, [language])


  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

 
  const { refetch: refetchAcademic } = useQuery(GET_ACTIVE_ACADEMIC_YEAR, {
    onCompleted: ({ getActiveAcademicYear }) => {
      setAcademicYearVal({
        id: getActiveAcademicYear?._id,
        title: getActiveAcademicYear?.academic_year
      });
    },
  });

  const { refetch, data } = useQuery(GET_STUDENT_PAGINATION, {
    variables: {
      academicYearId: academicYearVal?.id ? academicYearVal?.id : "",
      schoolId: schoolVal?.id ? schoolVal?.id : "",
      levelId: levelVal?.id ? levelVal?.id : "",
      teacherId: teacherVal?.id ? teacherVal?.id : "",
      groupId: groupVal?.id ? groupVal?.id : "",
      keyword: keyword,
      page: page,
      limit: limit,
      pagination: true,
      attendedStatus: studyStatusVal,
    },

    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
 
    if (data?.getStudentPagination) {
      setTableData(data.getStudentPagination?.data);
      setPaginationData(data.getStudentPagination?.paginator);
      setLoading(false);
    }
  }, [data])

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    refetch();
  }, [academicYearVal?.id, schoolVal?.id, levelVal?.id, teacherVal?.id, groupVal?.id, keyword, page, limit, studyStatusVal]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);



  const [stuIdToAction, setStuIdToAction] = useState();
  const [rowDetail, setRowDetail] = useState();



  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorElStu, setAnchorElStu] = React.useState(null);
  const openStu = Boolean(anchorElStu);
  const handleClickStu = (event, val, item) => {
    setAnchorElStu(event.currentTarget);
    setStuIdToAction(val);
    setRowDetail(item)
  };
  const handleCloseStu = () => {
    setAnchorElStu(null);
  };

  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`page-student`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`label-search`)}
            </Typography>
            <TextField
              placeholder={t(`label-search`)}
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#158843", fontSize: "22px" }}
                  >
                    <LuSearch />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 1.5 }}>
                  <Typography
                    className={
                      language === "kh" ? "header-text-kh" : "header-text"
                    }
                  >
                    {t(`academic_year`)}
                  </Typography>
                  <SelectAcademicYear
                    selectedVal={academicYearVal}
                    setSelectedVal={setAcademicYearVal}
                    className="search-field"
                    setLoading={setLoading}
                  />
                </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 1.8 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`school`)}
            </Typography>
            <SelectSchool
              selectedVal={schoolVal}
              setSelectedVal={setSchoolVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
              setLoading={setLoading}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 1.5 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`grade_level`)}
            </Typography>
            <SelectLevel
              selectedVal={levelVal}
              setSelectedVal={setLevelVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
              setLoading={setLoading}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 1.5 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`group`)}
            </Typography>
            <SelectGroup
              selectedVal={groupVal}
              setSelectedVal={setGroupVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
              setLoading={setLoading}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 1.5 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`teacher`)}
            </Typography>
            <SelectTeacher
              selectedVal={teacherVal}
              setSelectedVal={setTeacherVal}
              className="search-field"
              disabled={userLogin?.role === "Teacher" ? true : false}
              setLoading={setLoading}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3, lg: 2, xl: 1 }}>
            <Typography className={language === "kh" ? "header-text-kh" : "header-text"}>
              {t(`attended_status`)}
            </Typography>
            <FormControl size="small" fullWidth className="search-field">
              <Select
                value={studyStatusVal}
                onChange={(e) => { setStudyStatusVal(e.target.value); setLoading(true) }}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Drop out">Drop out</MenuItem>
                <MenuItem value="Certificate offer">Certificate offer</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3, lg: 2, xl: 1 }}>
            <Stack direction="row" justifyContent="right">
              {userLogin?.role === "Admin" ? (
                <Button
                  id="demo-customized-button"
                  aria-controls={open ? "demo-customized-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  variant="contained"
                  disableElevation
                  onClick={handleClick}
                  className="btn-create-style"
                  endIcon={<KeyboardArrowDownIcon />}
                >
                  {t("options")}
                </Button>
              ) : (<></>)}
            </Stack>
            <StudentBtnMenu
              open={open}
              handleClose={handleClose}
              anchorEl={anchorEl}
              setRefetch={refetch}
              userLogin={userLogin}
              academicYearVal={academicYearVal}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px`, whiteSpace: "nowrap" }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-start"
                      : "header-title-start-kh"
                  }
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_student_id")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_student_name")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_latin_name")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_gender")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("school")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("grade_level")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("group")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("attended_status")}
                </TableCell>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-end"
                      : "header-title-end-kh"
                  }
                ></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="table-body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="table-body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-start"
                                  : "body-cell-start-kh"
                              }
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {(paginationData?.perPage * (paginationData?.currentPage - 1)) + index + 1}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {/* {row?.student_id} */}

                              {String(row?.student_id ?? "").padStart(4, "0")}

                            </TableCell>
                            <TableCell
                              className="body-cell-kh"
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {row?.full_name_kh}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {row?.full_name_latin}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {row?.gender}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {/* {row?.phone_number} */}
                              {language === "en" ? row?.class_attended?.class_id?.school_id?.school_name_en : row?.class_attended?.class_id?.school_id?.school_name}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {row?.class_attended?.class_id?.level_id?.level_name}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              onClick={() =>
                                navigate(
                                  `/student/student-detail?id=${row?._id}`
                                )
                              }
                            >
                              {row?.class_attended?.class_id?.group_id?.group_name}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              // onClick={() =>
                              //   navigate(
                              //     `/student/student-detail?id=${row?._id}`
                              //   )
                              // }
                              align="center"
                            >

                              <Stack
                                className={
                                  row?.attended_status === "Drop out" ? "inactive-status-stu"
                                    : row?.attended_status === "Certificate offer" ? "finish-status-stu"
                                      : "active-status-stu"
                                }
                              >
                                {
                                  userLogin?.role === "Admin" ? (
                                    <Button sx={{ padding: "0px" }} onClick={(e) => handleClickStu(e, row?.class_attended?._id, row)}>
                                      <Typography className={language === "en" ? "status-txt" : "status-txt-kh"}>
                                        {row?.attended_status}
                                      </Typography>
                                    </Button>
                                  ) : (
                                    <Button sx={{ padding: "0px" }}>
                                      <Typography className={language === "en" ? "status-txt" : "status-txt-kh"}>
                                        {row?.attended_status}
                                      </Typography>
                                    </Button>
                                  )
                                }
                              </Stack>


                            </TableCell>

                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-end"
                                  : "body-cell-end-kh"
                              }
                              align="right"
                            >
                              {userLogin?.role === "Admin" ? (
                                <StudentAction
                                  editData={row}
                                  setRefetch={refetch}
                                  userLogin={userLogin}
                                
                                /> 
                              ) : (<></>)}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
      <StudentEnrollmentAction
        open={openStu}
        handleClose={handleCloseStu}
        anchorEl={anchorElStu}
        rowId={stuIdToAction}
        setRefetch={refetch}
        enrollmentTypeAction="student_page"
        rowDetail={rowDetail}
      />
    </div>
  );
}
